import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Especialidades</h2>
          <p>
            Oferecemos várias áreas de intervenção, pensadas para responder às necessidades específicas de cada utente. O nosso compromisso é cuidar da sua saúde de forma integrada, eficaz e humanizada.
          </p>
        </div>
        <div className="row" id="services-content">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`}>
                  {" "}
                  <i className={d.icon}></i>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
